/* ==========================================================================
   custom-overrides.js — amazonasfoods.com store customizations
   --------------------------------------------------------------------------
   This file is NOT part of the Xtra theme. It is loaded last (after
   custom.js and page-collection.js) from layout/theme.liquid, so anything in
   here can safely build on top of the theme's own JavaScript.

   Rule: put behaviour tweaks HERE instead of editing custom.js,
   page-collection.js or a section's inline <script>. On the next Xtra update
   this file survives untouched and only needs a quick re-test.

   Each block is numbered to match MODIFICATIONS.md.
   ========================================================================== */

(function () {
	'use strict';

	/* ----------------------------------------------------------------------
	   #13  Collection pages: infinite scroll

	   When the collection section's "Pagination type" is set to
	   "Infinite scroll", sections/main-collection.liquid renders a hidden
	   marker element (#collection-infinite-scroll) alongside the theme's
	   normal load-more markup.

	   This watches the theme's own "Show more products" button and clicks it
	   as it comes into view, so the shopper just keeps scrolling. Everything
	   else — the fetch, the append, the URL update, re-initialising quick
	   buy / ratings / swatches — is still done by the theme's existing
	   handler in page-collection.js. We only supply the click.

	   Deliberately conservative:
	   - Only [data-next] is ever auto-clicked. The "Show previous products"
	     and "Back to top" buttons are left alone.
	   - One load at a time; the next click can't fire until the theme has
	     announced the previous one finished.
	   - The same URL is never fetched twice.
	   - If JavaScript fails or IntersectionObserver is missing, the button
	     is still there and still works by hand. Nothing is hidden.
	   ---------------------------------------------------------------------- */

	var LOAD_AHEAD_PX = 600; // start loading this far before the button is on screen
	var MAX_AUTO_LOADS = 200; // runaway guard; ~10,000 products at 48/page

	var observer = null;
	var observedButton = null;
	var isLoading = false;
	var autoLoadCount = 0;
	var seenHrefs = Object.create(null);

	function isEnabled() {
		return !!document.getElementById('collection-infinite-scroll');
	}

	function disconnect() {
		if (observer) {
			observer.disconnect();
		}
		observedButton = null;
	}

	function handleIntersect(entries) {
		for (var i = 0; i < entries.length; i++) {
			if (!entries[i].isIntersecting) continue;

			var button = entries[i].target;
			if (isLoading) return;
			if (button.classList.contains('loading')) return;

			// The theme binds its click handler on the collectionLoadMore
			// event. If we somehow got here first, wait for the next tick.
			if (button.getAttribute('data-collection-load-more-bound') !== '1') return;

			var href = button.getAttribute('href');
			if (!href || seenHrefs[href]) return;

			if (autoLoadCount >= MAX_AUTO_LOADS) {
				disconnect();
				return;
			}

			seenHrefs[href] = true;
			autoLoadCount++;
			isLoading = true;

			// Stop watching the current button; the theme replaces it with a
			// fresh one and then fires collectionLoadMore, which re-binds us.
			disconnect();
			button.click();
			return;
		}
	}

	function init() {
		isLoading = false;

		if (!isEnabled()) {
			disconnect();
			return;
		}

		if (typeof window.IntersectionObserver !== 'function') return;

		var button = document.querySelector('#load-more-button[data-next]');

		if (!button) {
			disconnect();
			return;
		}

		if (button === observedButton) return;

		disconnect();

		if (!observer) {
			observer = new IntersectionObserver(handleIntersect, {
				root: null,
				rootMargin: LOAD_AHEAD_PX + 'px 0px',
				threshold: 0
			});
		}

		observedButton = button;
		observer.observe(button);
	}

	// The theme fires this after every load-more append and after every
	// filter / sort update, which is exactly when the button is replaced.
	window.addEventListener('collectionLoadMore', function () {
		// Let the theme finish swapping the DOM in before we look for it.
		requestAnimationFrame(init);
	});

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
